<template>
  <div v-if="pdfUrl" ref="pdfContainer" class="mt-5">
    <vue-pdf-app 
      style="height: 100vh;" 
      :pdf="pdfUrl"
      :config="config"
    ></vue-pdf-app>
  </div>
</template>

<script>
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";

export default {
  components: {
    VuePdfApp
  },
  props: {
    pdfUrl: {
      type: String,
      required: true,
      default: ""
    }
  },
  data() {
      return {
          config: {
              toolbar: {
                  toolbarViewerLeft: {
                  openFile: false
                  },
                  // O "Current View" fica geralmente no grupo da direita ou central
                  toolbarViewerRight: {
                  viewBookmark: false // Remove o ícone de link
                  }
              },
              secondaryToolbar: {
                  secondaryOpenFile: false,
                  secondaryViewBookmark: false // Remove do menu lateral/suspenso
              }
          }
      };
  },
  mounted() {
    // Escuta global para decidir quem recebe o zoom
    window.addEventListener("wheel", this.handleGlobalWheel, { 
      passive: false, 
      capture: true 
    });
  },
  beforeUnmount() {
    // Limpeza do listener ao destruir o componente
    window.removeEventListener("wheel", this.handleGlobalWheel, { 
      capture: true 
    });
  },
  methods: {
    handleGlobalWheel(event) {
      // Se Ctrl ou Command (Mac) estiver pressionado
      if (event.ctrlKey || event.metaKey) {
        const container = this.$refs.pdfContainer;
        const isOverPdf = container && container.contains(event.target);

        if (isOverPdf) {
          /**
           * MOUSE DENTRO:
           * Bloqueia o zoom da página (browser) para que o zoom interno
           * do PDF.js possa atuar sozinho.
           */
          event.preventDefault();
        } else {
          /**
           * MOUSE FORA:
           * Para a propagação para que o PDF.js não "roube" o evento.
           * O navegador seguirá com o zoom normal da página.
           */
          event.stopPropagation();
        }
      }
    }
  }
}
</script>

<style scoped>
/* Oculta o botão de Busca (Lupa) */
::v-deep #viewFind,
/* Oculta a Sidebar (Alternar Barra Lateral) */
::v-deep #sidebarToggle,
/* Oculta o Abrir Arquivo */
::v-deep #openFile, 
/* Oculta o Link da Visualização Atual */
::v-deep #viewBookmark
/* Oculta os 3 pontinhos (Menu de Ferramentas) */
 {
  display: none !important;
}
</style>